import React, { useState, useEffect } from 'react';
import { Descriptions } from "antd";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ItemView = function ItemView(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Descriptions, {
      title: item.label,
      column: 2,
      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Cat\xE9gorie",
        children: item.department.label
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Prix de base ",
        children: item.base_price.toLocaleString("Fr")
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Prix Soci\xE9t\xE9s ",
        children: item.ent_price.toLocaleString("Fr")
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Prix Assurances ",
        children: item.ins_price.toLocaleString("Fr")
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Prix Lanala ",
        children: item.lan_price.toLocaleString("Fr")
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Qte Disponible",
        children: item.available_quantity
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: "Stock minimal",
        children: item.minimal_stock
      })]
    })
  });
};

export default ItemView;